import { ordCheck, ordPending, ordForwardedNot, ordForwardedYes } from '../../../../../images/icons';
import { Rpm_PerfilesEstudios, SysI_Estudios } from '../../../../../types/types.estudios';

export const handleStatus = (data) => {
  if (data.value) {
    return <img src={ordCheck} title='Muestra recibida' alt='Muestra recibida' />;
  }
  return <img src={ordPending} title='Muestra pendiente' alt='Muestra pendiente' />;
};

export const handleForwarded = (data) => {
  if (data.value) {
    return <img src={ordForwardedYes} title='Muestra remitida' alt='Muestra remitida' />;
  }
  return <img src={ordForwardedNot} title='Muestra no remitida' alt='Muestra no remitida' />;
};

export const customExpression = (data: SysI_Estudios): any => {
  if (data === undefined) {
    return '';
  }
  return `${data.Es_Codigo} - ${data.Es_Nombre}`;
};

export const customProfileExpression = (data: Rpm_PerfilesEstudios): any => {
  if (data === undefined) {
    return '';
  }
  return `${data.SysI_PerfilesEstudios.Pfe_Abreviatura} - ${data.SysI_PerfilesEstudios.Pfe_Nombre}`;
};
